var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "web" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.flag,
            expression: "flag"
          }
        ],
        staticClass: "header"
      },
      [_vm._m(0)]
    ),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _c("div", { staticClass: "form" }, [
      _c("div", { staticClass: "title" }, [_vm._v("申请加入南阳链")]),
      _vm._v(" "),
      _c("div", { staticClass: "des" }, [
        _vm._v("请填写以下内容，我们会很快与您联系")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form_con" },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              attrs: { layout: "vertical", model: _vm.form, rules: _vm.rules }
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "企业名称", prop: "cstName" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入您的名字" },
                    model: {
                      value: _vm.form.cstName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cstName", $$v)
                      },
                      expression: "form.cstName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                { attrs: { label: "联系电话", prop: "concatPhone" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入您的电话号码" },
                    model: {
                      value: _vm.form.concatPhone,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "concatPhone", $$v)
                      },
                      expression: "form.concatPhone"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                { attrs: { label: "联系人名称", prop: "concatPerson" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入联系人名称" },
                    model: {
                      value: _vm.form.concatPerson,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "concatPerson", $$v)
                      },
                      expression: "form.concatPerson"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                { attrs: { label: "邮箱", prop: "concatEmail" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入您的邮箱" },
                    model: {
                      value: _vm.form.concatEmail,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "concatEmail", $$v)
                      },
                      expression: "form.concatEmail"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "des" }, [
            _vm._v(
              "\n        点击“提交”后我们会使用您的信息与您联系，告知您相关动态和特别优惠。请您确保信息准确无误，以便我们的客服专员联系您。\n      "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn_box" },
            [
              _c(
                "a-button",
                {
                  staticClass: "btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSave }
                },
                [_vm._v(" 提交 ")]
              )
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm._m(3)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header_con" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/web/logoh.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "nav" }, [
        _c("p", [_vm._v("首页")]),
        _vm._v(" "),
        _c("p", [_vm._v("南阳链")]),
        _vm._v(" "),
        _c("p", [_vm._v("联系我们")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [
      _c("div", { staticClass: "banner_con" }, [
        _c("img", {
          staticClass: "banner_img",
          attrs: {
            src: require("@/assets/images/web/banner.png"),
            alt: "",
            width: "100%"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "con" }, [
          _c("div", { staticClass: "des1" }, [
            _vm._v("区块链未来，共享更精彩")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "des2" }, [
            _vm._v(
              "\n          以数字科技打造南阳“区块链+”产业集群，以区块链技术，推进"
            ),
            _c("br"),
            _vm._v("\n          数字产业链。\n        ")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list" }, [
      _c("div", { staticClass: "title" }, [_vm._v("南阳链")]),
      _vm._v(" "),
      _c("div", { staticClass: "des" }, [_vm._v("南阳“区块链+”产业集群")]),
      _vm._v(" "),
      _c("div", { staticClass: "list_con" }, [
        _c("div", { staticClass: "item" }, [
          _c("img", {
            attrs: { src: require("@/assets/images/web/item1.png"), alt: "" }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "title" }, [_vm._v("自主创新")]),
          _vm._v(" "),
          _c("p", { staticClass: "des" }, [
            _vm._v(
              "\n          完成对区块链技术核心知识产权的自主研发。将区块链技术与如物联网、大数据、人工智能等其他新兴技术相结合，最大化发挥其效能。\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("img", {
            attrs: { src: require("@/assets/images/web/item2.png"), alt: "" }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "title" }, [_vm._v("安全高效")]),
          _vm._v(" "),
          _c("p", { staticClass: "des" }, [
            _vm._v(
              "\n          以安全高效为平台建设目标，搭建诚实可靠简单高效的区块链平台。分布式记账，各节点加密传输数据，各节点储存完整的交易信息，让交易处理更加安全且高效快捷。\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("img", {
            attrs: { src: require("@/assets/images/web/item3.png"), alt: "" }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "title" }, [_vm._v("开放分享")]),
          _vm._v(" "),
          _c("p", { staticClass: "des" }, [
            _vm._v(
              "\n          始于南阳，走出河南，目标全国。南阳链将搭建区块链基础设施，开放内部服务能力，与行业伙伴共享，共同推动可信互联网的发展，打造区块链的共赢生态。\n        "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer" }, [
      _c("div", { staticClass: "footer_top" }, [
        _c("img", {
          attrs: { src: require("@/assets/images/web/logof.png"), alt: "" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "nav" }, [
          _c("p", [_vm._v("商祺数贸")]),
          _vm._v(" "),
          _c("p", [_vm._v("南阳链")]),
          _vm._v(" "),
          _c("p", [_vm._v("联系我们")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer_bottom" }, [
        _vm._v(
          "\n      Copyright@2023       All rights\n      reserved.豫ICP备2023000680号\n    "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-528d4964", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-528d4964","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/web/index.vue
// module id = s270
// module chunks = 1